import { observer } from 'mobx-react-lite';
/* tslint:disable:jsx-no-lambda WI:47781 */
import * as React from 'react';
import { IPivotItemProps } from 'office-ui-fabric-react/lib/Pivot';
import { getInboxClassificationFilterForTable } from 'owa-mail-list-store';
import { TooltipHost, DirectionalHint, ITooltipStyles } from 'office-ui-fabric-react/lib/Tooltip';
import Droppable from 'owa-dnd/lib/components/Droppable';
import { DragData } from 'owa-dnd/lib/utils/dragDataUtil';
import { MailListRowDragData } from 'owa-mail-types/lib/types/MailListRowDragData';
import { lazyMoveRowsToInboxPlusPivot } from 'owa-mail-inbox-plus-actions';
import { mailStore } from 'owa-mail-store';
import { DraggableItemTypes } from 'owa-dnd';
import InboxPlusPivotViewState from 'owa-mail-inbox-plus-store/lib/store/schema/InboxPlusPivotViewState';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import { getSelectedTableView } from 'owa-mail-list-store';

const styles = require('./InboxPivotStyles.scss');
const classNames = require('classnames/bind').bind(styles);

export interface InboxPivotProps {
    link: IPivotItemProps;
    defaultRenderer: (props?: IPivotItemProps) => JSX.Element;
    pivot: InboxPlusPivotViewState;
    tableViewId: string;
}

export default observer(function InboxPivot(props: InboxPivotProps) {
    const renderUnseenCountBadge = (unseenCount: number): JSX.Element => {
        return (
            <div className={styles.badgeContainer}>
                <span className={styles.unseenCount}>{unseenCount}</span>
            </div>
        );
    };
    const renderRecentSenders = (pivot: InboxPlusPivotViewState): JSX.Element => {
        return (
            <>
                {/* TODO 77349: Fix inbox plus recent sender unlocalized string */}
                <span className={styles.recentSendersNewText}>{'New: '}</span>
                {pivot.recentSenders.join(', ')}
            </>
        );
    };
    const getTooltipStyles = (): Partial<ITooltipStyles> => {
        return {
            root: {
                display: 'flex',
                alignItems: 'center',
            },
        };
    };
    const canDrop_0 = (data?: DragData) => {
        const selectedPivot = getInboxClassificationFilterForTable(getSelectedTableView().id);
        const isValidDragType =
            mailStore.typeOfItemBeingDragged === DraggableItemTypes.MailListRow ||
            mailStore.typeOfItemBeingDragged === DraggableItemTypes.MultiMailListMessageRows ||
            mailStore.typeOfItemBeingDragged === DraggableItemTypes.MultiMailListConversationRows;
        const isSelected = selectedPivot === props.pivot.InboxClassificationFilter;
        const isDragFromAllPivot = selectedPivot === InboxClassificationFilter.None;
        return !isDragFromAllPivot && !isSelected && isValidDragType;
    };
    const onDropPivot = (dragInfo: DragData) => {
        const mailListRowDragData = dragInfo as MailListRowDragData;
        const selectedPivot = getInboxClassificationFilterForTable(getSelectedTableView().id);
        lazyMoveRowsToInboxPlusPivot
            .import()
            .then(moveRowsToInboxPlusPivot =>
                moveRowsToInboxPlusPivot(
                    mailListRowDragData.rowKeys,
                    selectedPivot,
                    props.pivot.InboxClassificationFilter,
                    mailListRowDragData.tableViewId,
                    'Drag'
                )
            );
    };
    const { link, defaultRenderer, pivot, tableViewId } = props;
    const canDrop = canDrop_0();
    const pivotStyles = classNames(
        styles.pivotItemContainer,
        canDrop && styles.dropContainer,
        pivot.drop.isDragOver && styles.dropHoverTreatment
    );
    const currentSelectedPivot = getInboxClassificationFilterForTable(tableViewId);
    const showUnseenData =
        pivot.unseenCount > 0 && pivot.InboxClassificationFilter !== currentSelectedPivot;
    return (
        <Droppable dropViewState={pivot.drop} onDrop={onDropPivot} canDrop={canDrop_0}>
            <TooltipHost
                tooltipProps={{
                    onRenderContent: () => (showUnseenData ? renderRecentSenders(pivot) : null),
                }}
                id={link.id}
                directionalHint={DirectionalHint.bottomCenter}
                styles={getTooltipStyles()}>
                <div className={pivotStyles}>
                    {defaultRenderer(link)}
                    {showUnseenData && renderUnseenCountBadge(pivot.unseenCount)}
                </div>
            </TooltipHost>
        </Droppable>
    );
});
